import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import { boot } from 'quasar/wrappers'

export default boot(({ app }) => {
  app.use(ToastPlugin, { position: 'bottom' })
})
